export default "/images/ca76ed004d5dffc84064f9194d76ba7b.jpg";